export default "__VITE_ASSET__NFbN1kLW__"